import React, {useState, useEffect} from 'react';
import * as S from './PersonalDetails.styles';
import * as C from '../../../Common.styles';
import {validations} from '../../../../../../utils/validations';

const PersonalDetails = ({data, errors, updateData, mobile, editEmail}) => {
    const[{
        title,
        fullName,
        email
    }, setPersonalInfo] = useState({
        title: data.title || '',
        fullName: data.fullName || '',
        email: data.email || ''
    });
    // const [errors, setError] = useState({error});
    const [emailDisabled, setEmailDisabled] = useState(true);
    const [linkedEmail,setLinkedEmail] = useState(data.email);

    useEffect(() => {
        if(data.email !== '' && editEmail){
            setEmailDisabled(false);
        }else{
            setEmailDisabled(true);
        }
    },[editEmail]);

    const onChangeHandler = (field, value) => {
        const data = {
          title,
          fullName,
          email
        };
        data[field] = value;
        setPersonalInfo(data);
        updateData(data);
    }


    return(
        <S.PersonalInfoWrap>
            <S.PersonalDetailsWrap>
                <S.PersonalDetailsHeadWrap>
                    <span />
                    <S.PersonalDetailsHeadText>Personal Details</S.PersonalDetailsHeadText>
                </S.PersonalDetailsHeadWrap>
            </S.PersonalDetailsWrap>
            <S.PersonalDetailsInfoWrap>
                <S.TitleNameWrap>
                    <S.TitleWrapper>
                        <C.CommonLabel>Title</C.CommonLabel>
                        <C.CommonSelect
                            value={title}
                            onChange={event => onChangeHandler('title', event.target.value)}
                            hasError={errors['title'] ? true : false}>
                            <option value="">Title</option>
                            <option value="1">Mr.</option>
                            <option value="2">Mrs.</option>
                            <option value="3">Ms.</option>
                        </C.CommonSelect>
                        <C.ErrorText>{errors['title']}</C.ErrorText>
                    </S.TitleWrapper>
                    <S.FullNameWrapper>
                        <C.CommonLabel>Full Name</C.CommonLabel>
                        <C.CommonInput
                            type="text"
                            placeholder="Your Full Name"
                            name="fullname"
                            value={fullName}
                            onChange={event => onChangeHandler('fullName', event.target.value)}
                            hasError={errors['fullName'] ? true : false}
                        />
                        <C.ErrorText>{errors['fullName']}</C.ErrorText>
                    </S.FullNameWrapper>
                </S.TitleNameWrap>
                <C.InputWrapper>
                    <S.EmailWrapper>
                        <C.CommonLabel>Email Address</C.CommonLabel>
                        <C.CommonInput
                            type="text"
                            placeholder="Email"
                            name="email"
                            value={email}
                            onChange={event => onChangeHandler('email', event.target.value)}
                            hasError={errors['email'] ? true : false}
                            // disabled={!emailDisabled ? true : false}
                        />
                        <C.ErrorText>{errors['email']}</C.ErrorText>
                        {!emailDisabled && <S.InfoText>Mobile number {mobile} is linked with {linkedEmail}. The same e-mail id will be linked to your myPartner account.You can continue with the above email-id or link a new email id to your myPartner account.</S.InfoText> || null }
                    </S.EmailWrapper>
                </C.InputWrapper>
            </S.PersonalDetailsInfoWrap>
        </S.PersonalInfoWrap>
    )
}

export default PersonalDetails;